import styled from "styled-components";
import PublicTemplate from "../publics/PublicTemplate";
import PeakMartCard from "../organisms/peak/PeakMartCard";
import { PeakTemplateProps } from "../../constants/types";
import { useEffect, useState } from "react";

const PeakTemplate = (props: PeakTemplateProps) => {
  const [elements, setElements] = useState<JSX.Element[]>([]);

  useEffect(() => {
    setElements(
      props.data.map((data, index) => <PeakMartCard data={data} key={index} />)
    );
  }, [props.data]);

  return (
    <PublicTemplate>
      <>
        <Content>{elements}</Content>
      </>
    </PublicTemplate>
  );
};

export default PeakTemplate;

const Content = styled.div`
  width: 100%;
  height: 100%;
  box-sizing: border-box;

  display: flex;
  align-content: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
`;
